import { useState, useEffect } from 'react';
import * as Sentry from '@sentry/react';
import clsx from 'clsx';

import useCountry from 'hooks/useCountry';

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Typography from 'components/CncUI/Typography';
import Checkbox from 'components/CncUI/Checkbox';
import AccountsTable from './AccountsTable';
import ErrorBoundary from 'components/ErrorBoundary';

const useStyles = makeStyles(({ palette }) => ({
  enabled: {
    color: palette.cncUI.default.primary,
  },
  header: {
    marginBottom: 0,
  },
}));

const InfoPanel = props => {
  const classes = useStyles();
  const { country } = useCountry();
  const isCanada = country === 'CAN';
  const { enabled, directDeposits, mappings } = props;
  const { isPaperLess = true } = (directDeposits && directDeposits[0]) || '';
  const [paperless, setPaperless] = useState(isPaperLess);

  useEffect(() => {
    setPaperless(
      directDeposits &&
        directDeposits.length > 0 &&
        directDeposits[0].isPaperLess,
    );
  }, [directDeposits]);

  const errorHandlerBadAccounts = () => {
    const accountsMetadata = directDeposits.map(account => ({
      id: account.id,
      isDirectDeposit: account.isDirectDeposit,
      splitPercentage: account.splitPercentage,
      bankAccountType: account.bankAccountType,
      isPaperLess: isCanada ? false : account.isPaperLess,
      isDeliveryRequested: account.isDeliveryRequested,
    }));
    Sentry.setContext('accountMetadata', accountsMetadata);
  };

  return (
    <Grid container spacing={2} style={{ flexGrow: 1 }}>
      {enabled ? (
        <>
          <Grid item xs={12}>
            <Typography
              variant="h4"
              size="medium"
              className={clsx(classes.header, classes.enabled)}
            >
              Direct Deposit is ON
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" size="long">
              {`The balance of your ${
                isCanada ? `paycheque` : `paycheck`
              } will be deposited into
              the account(s) below. Direct deposit can take up to 14
              calendar days from election before taking effect. Paper ${
                isCanada ? `cheques` : `checks`
              } will be issued when direct deposit is not available.`}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="h5">Your direct deposit accounts</Typography>
          </Grid>
          <Grid item xs={12}>
            <ErrorBoundary alert errorHandler={errorHandlerBadAccounts}>
              <AccountsTable
                mappings={mappings}
                directDeposits={directDeposits}
                setPaperless={setPaperless}
              />
            </ErrorBoundary>
          </Grid>
          {!isCanada && (
            <Grid item xs={12} style={{ paddingLeft: 24 }}>
              <Checkbox disabled checked={paperless}>
                Go paperless to view your pay stubs online.
              </Checkbox>
            </Grid>
          )}
        </>
      ) : (
        <>
          <Grid item xs={12} id="DirectDeposit-off">
            <Typography variant="h4" size="medium" className={classes.header}>
              Direct Deposit is OFF
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography variant="body2" size="short" noMargin>
              {`You will receive paper ${isCanada ? `cheques` : `checks`}.`}
            </Typography>
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default InfoPanel;
